import { FC, useCallback } from 'react';
import {
  CenterContent,
  CenterContentControls,
  CenteredScreenLayout,
  EmptyCenterLeft,
  EmptyCenterRight,
  EmptyFooter,
  EmptyHeader,
  StructuredText,
} from '../../Components/CenteredScreenLayout';

export type PurposePrefaceProps = {
  authorization: string;
};

export const PurposePreface: FC<PurposePrefaceProps> = ({ authorization }) => {
  const onStartInterview = useCallback(async () => {
    history.pushState({}, '', '/interview/start');
  }, []);

  return (
    <CenteredScreenLayout>
      <EmptyHeader />
      <EmptyCenterLeft />
      <CenterContent>
        <strong>Purpose:</strong>
        <br />
        <br />
        <StructuredText>
          To be interviewed as if you were exploring an entrepreneurial financial advisor career opportunity! The
          interview is text/chat based and should take under 15 minutes. There will be an opportunity for one audio
          based question at the end. Please answer questions as you would wish to appear in an interview transcript. At
          the end of the interaction, we will share our opinion on if you should explore being an advisor or if you
          should consider a different path at this time. If we think it could be a good fit, you could potentially hear
          from financial planning firms that are hiring. If we think that it may not be the best time to pursue an
          advisor career, we will share resources to help you learn about other paths in financial planning or steps to
          prepare for the advisor career at a later date.
        </StructuredText>
        <br />
        <CenterContentControls>
          <button onClick={onStartInterview}>Next</button>
        </CenterContentControls>
      </CenterContent>
      <EmptyCenterRight />
      <EmptyFooter />
    </CenteredScreenLayout>
  );
};
